import { AppState, AssetClassMeta } from '../types';

// ─── Buckets ─────────────────────────────────────────────────────────────────
const buckets = [
  { id: 'ruong-chua', name: 'Danh mục Chung', description: 'Danh mục mặc định chứa tài sản chưa được phân bổ vào danh mục cụ thể', targetValue: 0, color: '#64748b', icon: 'inbox' },
];

// ─── Asset Classes (Master Data) ──────────────────────────────────────────────
export const DEFAULT_ASSET_CLASSES: AssetClassMeta[] = [
  { id: 'bds',               name: 'BĐS',               color: '#10b981' },
  { id: 'co-phieu',          name: 'Cổ phiếu',          color: '#38bdf8' },
  { id: 'thu-nhap-co-dinh',  name: 'Thu nhập cố định',  color: '#fbbf24', isFixedIncome: true },
  { id: 'tien-mat',          name: 'Tiền mặt & Tương đương', color: '#a78bfa' },
  { id: 'vang',              name: 'Vàng vật chất',     color: '#f59e0b' },
  { id: 'crypto',            name: 'Tiền điện tử',      color: '#8b5cf6' },
  { id: 'khac',              name: 'Khác',              color: '#94a3b8' },
];

// ─── Initial State ────────────────────────────────────────────────────────────
export const INITIAL_DATA: AppState = {
  assets: [],
  transactions: [],
  moneyTransactions: [],
  priceHistory: [],
  buckets,
  cashFlowEvents: [],
  liabilities: [],
  repayments: [],
  monthlyExpenses: [],
  assetClasses: DEFAULT_ASSET_CLASSES,
  holdings: [],
  lastUpdated: new Date().toISOString(),
};
